<template>
  <div class="auth-personl flex-column">
    <div class="flex-column-1">
      <mt-loadmore style="min-height: 100%;" :top-method="loadTop" :autoFill="true" ref="loadmore">
        <div class="header">
          <img class="cover" :src="require('@/assets/imgs/auth/cover.png')" alt />
          <div class="userInfoBox">
            <img class="portrait" :src="userInfo.portrait" alt />
            <div class="baseInfo">
              <p class="phone">{{ userInfo.phone }}</p>
              <p class="navToDetail">
                个人信息
                <!--<i class="icon iconfont icon-arrowRight"></i>-->
              </p>
            </div>
          </div>
        </div>
        <div class="body flex-column-1">
          <template v-for="(fn, index) in functions">
          <div class="content" :key="index" v-if="!specialList || specialList.includes(fn.title)">
            <div class="line-box" v-if="index != 0"></div>
            <div class="content-bottom">
              <p class="title">
                {{ fn.title}}
                <span v-if="fn.allOrder" @click="toAll">全部订单<i class="icon iconfont icon-arrowRight"></i></span>
              </p>
              <ul class="itemsBox">
                <template v-for="(item, index) in fn.content">
                <li
                  class="item"
                  @click="goto(item.text, item.msg, item.path, item.phone, item.otherProject), seting(item.seting)"
                   v-if="!specialList || specialList.includes(item.name)"
                  :key="index"
                >
                  <img class="item-img" :src="item.icon" alt />
                  <p>{{ item.name }}</p>
                </li>
                </template>
              </ul>
            </div>
          </div>
          </template>
        </div>
        <div slot="top" class="mint-loadmore-top">
          <img style="height:65px;width:100%" src="../../../assets/imgs/home/otmsLoading.gif" alt="" />
        </div>
      </mt-loadmore>
    </div>
    <NavbarFooter />
  </div>
</template>
<script>
import { ROOT_REQUEST } from "@/assets/configs";
import { MessageBox, Loadmore } from "mint-ui";
export default {
  name: "authPersonl",
  methods: {
    toAll() {
      location.href = ROOT_REQUEST.web_base + "h5/parkmall/#/myorder/all?tab=0&origin=specialline";
    },
    goto(val, msg, path, phone, otherProject) {
      if (path) {
        if (otherProject) {
          localStorage.setItem("origin", "specialline");
          var vm = this;
          let urlParmars = window.localStorage.getItem("userId")
            ? window.localStorage.getItem("userId").split(" ")[1]
            : "";
          let account = localStorage.getItem("mobile") || "";
          if (urlParmars) {
            location.href = path;
          } else {
            if (this.isWeiXin()) {
              wx.miniProgram.getEnv(function(res) {
                if (res.miniprogram) {
                  localStorage.setItem("zxRedirction", vm.$route.fullPath);
                  wx.miniProgram.navigateTo({
                    url: "/pages/wxLogin/wxLogin?redirection="
                  });
                }
              });
              setTimeout(function() {
                vm.$router.push({ name: "auth-login", query: { redirect: vm.$route.fullPath } });
              }, 1000);
            } else {
              vm.$router.push({ name: "auth-login", query: { redirect: vm.$route.fullPath } });
            }
          }
        } else {
          if (path == "callect") {
            this.$router.push({ name: "callect-company-list", query: {} });
          } else if (path == "inviteBusiness") {
            this.$router.push({ name: "inviteBusiness", query: {} });
          }
        }
      }
      if (phone) {
        if (sessionStorage.getItem("useCompany") == "hdzxcc") {
          this.companyTel = "400-0318-822";
        }
        if (sessionStorage.getItem("useCompany") == "hyzxcc") {
          this.companyTel = "4008836568";
        }
        if (sessionStorage.getItem("useCompany") == "byzxcc") {
          this.companyTel = "010-58565158";
        }
        if (sessionStorage.getItem("useCompany") == "linanzxcc") {
          this.companyTel = "010-58565158";
        }
        if (sessionStorage.getItem("useCompany") == "yingtanwlcc") {
          this.companyTel = "13807019127";
        }
        if (sessionStorage.getItem("useCompany") == "ywglg") {
          this.companyTel = "0579-85022561";
        }
        window.location.href = "tel://" + this.companyTel;
      }
    },
    seting(set) {
      set && this.$router.push({ name: "auth-logout" });
    },
    loadTop() {
      setTimeout(() => {
        this.$refs.loadmore.onTopLoaded();
      }, 1000);
    }
  },
  data() {
    return {
      specialList:[],//物流园特定列表
      companyTel: "010-58565158",
      userInfo: {
        portrait: require("@/assets/imgs/auth/defaultPortrait.png"),
        phone: localStorage.getItem("mobile") || ""
      },
      functions: [
        {
          title: "个人服务",
          content: [
            {
              icon: require("@/assets/imgs/auth/favorite.png"),
              name: "收藏",
              text: "暂无收藏",
              msg: true,
              path: "callect",
              otherProject: false
            },
            {
              icon: require("@/assets/imgs/auth/zhaoshang.png"),
              name: "发布招商",
              text: "暂无收藏",
              msg: true,
              path: "inviteBusiness",
              otherProject: false
            }
            //          {
            //            icon: require("@/assets/imgs/auth/history.png"),
            //            name: "历史记录",
            //            text: "暂无历史记录",
            //            msg: true
            //          }
          ]
        },
        {
          title: "我的订单",
          allOrder: true,
          content: [
            {
              icon: require("@/assets/imgs/auth/payment.png"),
              name: "待付款",
              text: "待付款",
              msg: true,
              path: ROOT_REQUEST.web_base + "h5/parkmall/#/myorder/all?tab=1&origin=specialline",
              otherProject: true
            },
            {
              icon: require("@/assets/imgs/auth/daishou.png"),
              name: "待收/提货",
              text: "待收/提货",
              msg: true,
              path: ROOT_REQUEST.web_base + "h5/parkmall/#/myorder/all?tab=2&origin=specialline",
              otherProject: true
            },
            {
              icon: require("@/assets/imgs/auth/eval.png"),
              name: "待评价",
              text: "待评价",
              msg: true,
              path: ROOT_REQUEST.web_base + "h5/parkmall/#/myorder/all?tab=2&origin=specialline",
              otherProject: true
            },
            {
              icon: require("@/assets/imgs/auth/accomplish.png"),
              name: "已完成",
              text: "已完成",
              msg: true,
              path: ROOT_REQUEST.web_base + "h5/parkmall/#/myorder/all?tab=3&origin=specialline",
              otherProject: true
            }
          ]
        },
        {
          title: "常用工具",
          content: [
            {
              icon: require("@/assets/imgs/auth/set.png"),
              name: "设置",
              text: "设置",
              msg: false,
              seting: true
            },
            {
              icon: require("@/assets/imgs/auth/connect.png"),
              name: "联系我们",
              text: "4008866956",
              phone: "010-58565158",
              msg: true
            }
            //          {
            //            icon: require("@/assets/imgs/auth/help.png"),
            //            name: "帮助",
            //            text: "4008866956",
            //            phone:"010-58565158",
            //            msg: true
            //          }
          ]
        }
      ]
    };
  },
  mounted() {
    if (sessionStorage.getItem("useCompany") == "hdzxcc") {
      this.companyTel = "400-0318-822";
    }
    if (sessionStorage.getItem("useCompany") == "hyzxcc") {
      this.companyTel = "4008836568";
    }
    if (sessionStorage.getItem("useCompany") == "byzxcc") {
      this.companyTel = "010-58565158";
    }
    if (sessionStorage.getItem("useCompany") == "ywglg") {
      this.companyTel = "0579-85022561";
      //只留收藏
      this.specialList = ["个人服务","常用工具","收藏","设置","联系我们"]
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  position: relative;
  height: 4.1rem;
  .cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .userInfoBox {
    position: absolute;
    color: white;
    top: 1rem;
    left: 0.45rem;
    .portrait {
      width: 1.4rem;
      height: 1.4rem;
      object-fit: cover;
      display: inline-block;
    }
    .baseInfo {
      display: inline-block;
      position: absolute;
      width: 3rem;
      left: 2.4rem;
      .phone {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 10px;
      }
      .navToDetail {
        font-size: 15px;
        .icon {
          font-size: inherit;
        }
      }
    }
  }
}
.body {
  box-sizing: border-box;
  .content-bottom {
    padding: 14px;
    .title {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 0.2rem;
      color: rgba(51, 51, 51, 1);
      padding-right: 0.4rem;
      span {
        float: right;
        font-size: 13px;
        color: #989898;
      }
      .icon-arrowRight {
        font-size: 13px;
        margin-left: 4px;
      }
    }
    .itemsBox {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 0;
      .item {
        width: 25%;
        display: inline-block;
        font-size: 13px;
        line-height: 0.8rem;
        color: rgba(32, 41, 76, 1);
        text-align: center;
        img {
          display: inline-block;
          width: 0.8rem;
        }
        p {
          margin-bottom: 0.05rem;
        }
      }
    }
  }
  .line-box {
    width: 100%;
    height: 0.2rem;
    background-color: #f7f8fb;
  }
}
</style>

